import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import SatRobotControlPanel from "@/components/disenador/SatRobotControlPanel";
import { Power } from "lucide-react";

/**
 * Tarjeta plegable del robot SAT en el hub del módulo Diseñador (inicia cerrada).
 */
export default function SatRobotHubAccordion() {
  return (
    <Accordion
      type="single"
      collapsible
      className="rounded-sm border border-slate-200 bg-white shadow-sm"
      data-testid="designer-hub-sat-robot-accordion"
    >
      <AccordionItem value="sat-robot" className="border-0">
        <AccordionTrigger
          className="px-4 py-3 hover:no-underline"
          data-testid="designer-hub-sat-robot-trigger"
        >
          <span className="flex items-center gap-2 text-sm font-semibold text-[#0F2D5C]">
            <Power className="w-4 h-4 shrink-0 text-amber-700" aria-hidden />
            Robot SAT — encendido / apagado
          </span>
        </AccordionTrigger>
        <AccordionContent className="px-4 pb-4 pt-0 border-t border-slate-100">
          <SatRobotControlPanel embedded />
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
